import styled, { css } from 'styled-components'
import pxToRem from '../../utils/pxToRem'

import Button from '../Button/Button'
import ArrowIcon from '../../images/icons/arrow-right.svg'
import DoubleArrowIcon from '../../images/icons/double-arrow.svg'

export const StyledPaginator = styled.nav`
  justify-content: center;
  display: flex;
  margin-top: ${pxToRem(30)};
`

export const StyledPaginatorList = styled.ul`
  justify-content: center;
  align-items: center;
  display: flex;
`

export const IconRotation = css`
  transform: rotate(180deg);
`

export const ArrowRightIcon = styled(ArrowIcon)`
  /* for optical alignment */
  margin-right: ${pxToRem(1)};
`

export const DoubleArrowLeftIcon = styled(DoubleArrowIcon)`
  /* for optical alignment */
  padding-right: ${pxToRem(2)};
`

export const DoubleArrowRightIcon = styled(DoubleArrowLeftIcon)`
  ${IconRotation}
`

export const ArrowLeftIcon = styled(ArrowRightIcon)`
  /* for optical alignment */
  margin-right: 0;
  ${IconRotation}
`

export const StyledPaginatorButton = styled(Button)`
  align-items: center;
  justify-content: center;
  display: flex;
  margin: 0 ${pxToRem(5)};
  border: none;
  border-radius: ${pxToRem(21)};
  min-width: ${pxToRem(21)};
  max-height: ${pxToRem(21)};
  padding: ${pxToRem(5)};
  background-color: ${({ $active, theme }) =>
    $active ? theme.colors.unique.black : 'transparent'};
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  line-height: initial;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.unique.white : theme.colors.primary.grey};
  &:hover {
    border: none;
    background-color: ${({ theme }) => theme.colors.unique.black};
    color: ${({ theme }) => theme.colors.unique.white};
  }
`

export const StyledIconButton = styled(Button)`
  justify-content: center;
  display: flex;
  margin: 0 ${pxToRem(5)} ${pxToRem(0)} ${pxToRem(5)};
  border: none;
  border-radius: ${pxToRem(21)};
  width: ${pxToRem(21)};
  height: ${pxToRem(21)};
  &:hover {
    border: inherit;
    background-color: ${({ theme }) => theme.colors.unique.black};
    path {
      fill: ${({ theme }) => theme.colors.unique.white};
    }
  }
`

export const StyledPaginatorDots = styled.p`
  margin: 0 ${pxToRem(5)} ${pxToRem(0)} ${pxToRem(5)};
  width: ${pxToRem(24)};
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  line-height: initial;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  text-align: center;
  color: ${({ theme }) => theme.colors.primary.grey};
`
